import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Cadastro from './components/CadastroExterno';
import DashboardCRM from './components/CRM/Dashboard';
import DashboardFormalizacao from './components/Formalizacao/Dashboard/Dashboard';
import ForceLogout from './components/ForceLogout/ForceLogout';
import DashboardRelacionamentos from './components/Relacionamentos/DashboardRelacionamentos';
import PlataformasAutenticacao from './services/authentication/PlataformasAutenticacao';
import ProtectedRoute from './services/authentication/ProtectedRoute';
import NotFound from './components/NotFound/NotFound';
import {
  carregarEscopoAmbienteTenant,
  getEscopoComponentes,
  isAuthenticated
} from './services/authentication/auth';
import LoaderMain from './components/Shared/LoaderMain';
import Error from './components/NotFound/Error';

const RotaSistema = ({ children, props }) => {
  const [configAmbiente, setConfigAmbiente] = useState(false);

  useEffect(() => {
    carregarEscopoAmbienteTenant(configs => {
      setConfigAmbiente(configs);
    });
  }, []);

  useEffect(() => {
    if (configAmbiente !== false) {
      if (document && document.title && configAmbiente.sistema && configAmbiente.sistema.tenant_name)
        document.title = `${configAmbiente.sistema.tenant_name.toLocaleUpperCase()} | Plataforma Digital`;

      const favicon = document ? document.getElementById('favicon') : false;
      const faviconUrl =
        configAmbiente && configAmbiente.imagens && configAmbiente.imagens.FAVICON
          ? configAmbiente.imagens.FAVICON
          : '';
      if (favicon) favicon.href = faviconUrl;
    }
  }, [configAmbiente]);

  return (
    <>
      {configAmbiente !== false && Object.keys(configAmbiente).length > 0 ? (
        <>{children}</>
      ) : configAmbiente === false ? (
        <div className="wrapper">
          <LoaderMain />
        </div>
      ) : (
        <div className="wrapper">
          <Error />
        </div>
      )}
    </>
  );
};

const Rotas = () => {
  const [escopoAcesso, setEscopoAcesso] = useState(isAuthenticated() ? getEscopoComponentes() : false);

  return (
    <Routes>
      <Route
        path="/plataformas-autenticacao/:url/:tokenRefresh/:token"
        element={
          <RotaSistema>
            <PlataformasAutenticacao setEscopoAcesso={setEscopoAcesso} />
          </RotaSistema>
        }
      />

      <Route
        path="/cadastro"
        element={
          <RotaSistema>
            <Cadastro />
          </RotaSistema>
        }
      />

      <Route
        path="/plataforma_crm/dashboard"
        element={
          <RotaSistema>
            <ProtectedRoute modulo="plataforma_crm" contexto="dashboard" escopoAcesso={escopoAcesso}>
              <DashboardCRM escopoAcesso={escopoAcesso} />
            </ProtectedRoute>
          </RotaSistema>
        }
      />

      <Route
        path="/plataforma_formalizacao/dashboard"
        element={
          <RotaSistema>
            <ProtectedRoute
              modulo="plataforma_formalizacao"
              contexto="dashboard"
              escopoAcesso={escopoAcesso}
            >
              <DashboardFormalizacao escopoAcesso={escopoAcesso} />
            </ProtectedRoute>
          </RotaSistema>
        }
      />

      <Route
        path="/plataforma_relacionamento/dashboard"
        element={
          <RotaSistema>
            <ProtectedRoute
              modulo="plataforma_relacionamento"
              contexto="dashboard"
              escopoAcesso={escopoAcesso}
            >
              <DashboardRelacionamentos escopoAcesso={escopoAcesso} />
            </ProtectedRoute>
          </RotaSistema>
        }
      />

      <Route path="/force-logout" element={<ForceLogout />} />

      <Route path="/not-found" element={<NotFound escopoAcesso={escopoAcesso} />} />

      <Route
        path="*"
        element={
          <ProtectedRoute ignorarEscopo={true}>
            <NotFound erro="Rota não encontrada." escopoAcesso={escopoAcesso} />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default Rotas;
